import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M9.713 17.735c0-.446.361-.806.806-.806h10.964c.446 0 .807.36.807.806v1.048a6.288 6.288 0 1 1-12.577 0v-1.048Z",
      stroke: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M23.604 8.747a.594.594 0 0 1-.82.012A10.087 10.087 0 0 0 16 6.143c-2.606 0-4.984.989-6.785 2.616a.594.594 0 0 1-.819-.012.547.547 0 0 1 .01-.79A11.21 11.21 0 0 1 16 5a11.21 11.21 0 0 1 7.594 2.957c.23.21.23.569.01.79ZM20.388 11.197a.534.534 0 0 1 .016.783c-.222.225-.584.222-.828.02A5.598 5.598 0 0 0 16 10.715a5.598 5.598 0 0 0-3.576 1.287c-.244.201-.606.204-.828-.021a.534.534 0 0 1 .016-.784A6.721 6.721 0 0 1 16 9.572c1.673 0 3.205.612 4.388 1.626Z",
      fill: "currentColor"
    })]
  }));
};
export default SvgComponent;